import { useState } from "react";
import AgendaSemana from "@/components/AgendaSemana";
import AgendaDia from "@/components/AgendaDia";
import { Button } from "@/components/ui/button";
import { CalendarDays, CalendarClock, RefreshCw } from "lucide-react";

export default function Agenda() {
  const [section, setSection] = useState("semana");
  const [refreshKey, setRefreshKey] = useState(0);
  const [refreshing, setRefreshing] = useState(false);

  const handleRefresh = () => {
    setRefreshing(true);
    setRefreshKey((k) => k + 1);
    setTimeout(() => setRefreshing(false), 700);
  };

  return (
    <div>
      <div className="flex items-start justify-between gap-3 mb-1">
        <h1 className="text-2xl sm:text-3xl font-bold font-heading text-slate-100">Agenda</h1>
        <Button data-testid="agenda-refresh-button" onClick={handleRefresh} disabled={refreshing} variant="outline"
          className="h-10 px-3 sm:px-4 border-[#263147] bg-[#181F2C] text-slate-200 hover:bg-[#1E2738] rounded-xl shrink-0">
          <RefreshCw className={`w-4 h-4 sm:mr-2 ${refreshing ? "animate-spin" : ""}`} />
          <span className="hidden sm:inline">Atualizar</span>
        </Button>
      </div>
      <p className="text-sm text-slate-400 mb-6">Monte a semana e acompanhe o dia com presença e relatório.</p>

      <div className="flex gap-2 mb-6 bg-[#181F2C] border border-[#263147] rounded-2xl p-1.5 w-full sm:w-auto sm:inline-flex">
        <button data-testid="agenda-tab-semana" onClick={() => setSection("semana")}
          className={`flex-1 sm:flex-none flex items-center justify-center gap-2 h-11 px-5 rounded-xl text-sm font-medium transition-colors ${
            section === "semana" ? "bg-emerald-500 text-[#0A0D12]" : "text-slate-400 hover:text-slate-200"
          }`}>
          <CalendarDays className="w-4 h-4" /> Semana
        </button>
        <button data-testid="agenda-tab-dia" onClick={() => setSection("dia")}
          className={`flex-1 sm:flex-none flex items-center justify-center gap-2 h-11 px-5 rounded-xl text-sm font-medium transition-colors ${
            section === "dia" ? "bg-emerald-500 text-[#0A0D12]" : "text-slate-400 hover:text-slate-200"
          }`}>
          <CalendarClock className="w-4 h-4" /> Dia
        </button>
      </div>

      <div key={section}>
        {section === "semana" ? <AgendaSemana refreshKey={refreshKey} /> : <AgendaDia refreshKey={refreshKey} />}
      </div>
    </div>
  );
}
